module.exports = __webpack_public_path__ + "18b1d3897123237b99bbff2d58b62fe0.png";